export default __webpack_public_path__ + "5a351c86310e29ed16bf93a67916dd35.png";